import { AxiosInstance } from 'axios'
import nProgress from 'nprogress'
import { baseApiURL, apiEndPoints } from '../config'
import { StatusCode } from 'src/context/common'

export default class UserManagement {
  apiServer: AxiosInstance
  baseUrl = `${baseApiURL}user-management/`
  constructor(apiServer: AxiosInstance) {
    this.apiServer = apiServer
  }

  async getRefreshToken() {
    nProgress.start()
    const endUrlName = baseApiURL + apiEndPoints.refreshToken
    const response = await this.apiServer.get(endUrlName)
    nProgress.done()

    return response
  }
  async getUserDetails(email: any) {
    nProgress.start()
    const endUrlName = `${this.baseUrl + apiEndPoints.userDetails}/${email}`
    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data?.data
    } catch (err: any) {
      console.log('Error while fetching user details =========>')
    } finally {
      nProgress.done()
    }
  }
  async getRoles() {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.roles
    try {
      const response = await this.apiServer.get(endUrlName)

      return response.status === StatusCode?.Success && response.data.statusCode === StatusCode?.Success
        ? response.data.data
        : []
    } catch (err: any) {
      console.log('Error fetching Roles list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }
  async requestAssess(payload: any) {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.requestAccess
    try {
      const response = await this.apiServer.post(endUrlName, payload)
      nProgress.done()

      return response
    } catch (err: any) {
      console.log('Error fetching Account Manager List ========>', err?.message)
      nProgress.done()
    }
    nProgress.done()
  }
  async getAgents(role: string) {
    nProgress.start()
    const endUrlName = `${this.baseUrl + apiEndPoints.agents}/${role}`
    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data?.data ? response.data.data : []
    } catch (err: any) {
      console.log('Error fetching Agents list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async getAgentDetails(agentCode: string) {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.agentDetailsByCode
    try {
      const response = await this.apiServer.get(`${endUrlName}/${agentCode}`)
      nProgress.done()

      return response?.data?.data
    } catch (err: any) {
      console.log('Error fetching agent detail ========>', err?.message)
      nProgress.done()
    }
    nProgress.done()
  }
}
